import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-alumni-association',
    templateUrl: './alumni-association.component.html',
    styleUrls: ['./alumni-association.component.scss']
})
export class AlumniAssociationComponent implements OnInit {
    src: string = '/assets/pdf/Alumni Association.pdf';
    title: string = 'Alumni Association';

    constructor() { }

    ngOnInit(): void {
    }

}
